var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5001,
    r: 12.5,
    fill: "white",
    stroke: "#1A2746",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0258 7.00012H20.1726L15.4825 12.3605L21 19.6548H16.6799L13.2962 15.2309L9.42452 19.6548H7.27644L12.2929 13.9213L7 7.00012H11.4298L14.4883 11.0438L18.0258 7.00012ZM17.2724 18.3699H18.4619L10.7834 8.21756H9.50692L17.2724 18.3699Z",
    fill: "#0D2548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonX);
export default __webpack_public_path__ + "static/media/button-x.f0d8f51a780a5d1cc337fdde826b227e.svg";
export { ForwardRef as ReactComponent };